import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

// REPLACE THESE VALUES with your actual Firebase Project config
const firebaseConfig = {
  apiKey: "AIzaSyBS2B-ujTg35E2D-jRBfaW5vx_iMbH6UVY",
  authDomain: "estudiohub-prod.firebaseapp.com",
  projectId: "estudiohub-prod",
  storageBucket: "estudiohub-prod.firebasestorage.app",
  messagingSenderId: "872034432278",
  appId: "1:872034432278:web:945bbc305c5d3abc180c37",
  measurementId: "G-HNN87MTZ2T",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Your VAPID Key from Firebase Console (Web Push certificates)
const VAPID_KEY =
  "BKfAAIMPmM8XkTcrcNZkEyxPeOeIv9aExrUqrz7ydcf2VfbEZIi8JOpyUAZ1lspmeLMwSTayDgWLHVDxhEm4_BM";

/**
 * Safely retrieves the messaging instance, checking for browser support first.
 * Prevents unhandled promise rejections on environments without Push API support (e.g., standard iOS Safari).
 *
 * @returns {Promise<any|null>} The messaging instance or null if unsupported.
 */
async function getSupportedMessaging() {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    }

    console.warn(
      "Firebase Messaging is not supported in this browser environment.",
    );
    return null;
  } catch (error) {
    console.error("Error evaluating Firebase Messaging support:", error);
    return null;
  }
}

/**
 * Requests the FCM Token, explicitly registering and waiting for the Service Worker.
 *
 * @returns {Promise<string|null>} The FCM token or null if denied
 */
export async function requestFcmToken() {
  try {
    // 1. Ensure permission is granted before proceeding.
    if (Notification.permission !== "granted") {
      console.warn("Notification permission is not granted.");
      return null;
    }

    // 2. Safely get the messaging instance
    const messaging = await getSupportedMessaging();
    if (!messaging) return null;

    // 3. Register the Service Worker
    await navigator.serviceWorker.register("/firebase-messaging-sw.js");

    // NEW: Wait explicitly for the Service Worker to be fully active and ready
    const registration = await navigator.serviceWorker.ready;

    // 4. Retrieve the token using the explicit, active SW registration
    // @ts-ignore: getToken is currently marked as deprecated in Firebase TS definitions, but remains the official API.
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    return token;
  } catch (error) {
    console.error("Error retrieving FCM token:", error);
    return null;
  }
}

/**
 * Listens for foreground messages (when the user has the tab open).
 *
 * @param {Function} callback
 */
export async function onForegroundMessage(callback) {
  try {
    const messaging = await getSupportedMessaging();

    if (!messaging) return;

    onMessage(messaging, (payload) => {
      callback(payload);
    });
  } catch (error) {
    console.error("Error setting up foreground message listener:", error);
  }
}
